(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Fredz-horizontal-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const prevArrow = document.querySelector('.custom-arrows .slick-prev');
  const nextArrow = document.querySelector('.custom-arrows .slick-next');

  $('.horizontal-slider').slick({
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: prevArrow,
    nextArrow: nextArrow
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animated-comparison"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("in-view");
      } else {
        entry.target.classList.remove("in-view");
      }
    });
  }, {
    threshold: 0.3
  });

  document.querySelectorAll(".on-view-section").forEach(el => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["richtext-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const prevArrow = document.querySelector('.custom-arrows .slick-prev');
  const nextArrow = document.querySelector('.custom-arrows .slick-next');

  $('.custom-home-slider').slick({
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: prevArrow,
    nextArrow: nextArrow
  });
});


  } catch(e) { console.error(e); }
})();
})();
